import styles from "./components.module.scss";
import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import React from "react";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";
import {SimpleModal} from "components/Modal";
import {openExternalUrlFromLink} from "utils/nativeApp";

export const CHANGE_SHIFT_HOURS_POLICY =
    'https://support.tempstars.com/hc/en-us/articles/26373358690195-I-Need-to-change-posted-shift-hours-Office-change-in-shift-schedule';

export const CannotCallModal = ({ firstName, onCloseButtonClick}: { firstName: string, onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Phone Number Not Yet Available</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                Their phone number will become available 2h before the shift. Reach out to {firstName} via the chat button if you need to connect!
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx(styles.okButton)}
            >
                OK
            </StyledButton>
        </>
    );
}

export const PhoneNumberModal = ({ firstName, phone, onCloseButtonClick}: { firstName: string, phone: string, onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Call {firstName}</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                You can now reach {firstName} at:
                <div style={{ fontSize: "1.5rem", fontWeight: 700, textAlign: "center", margin: "0.75rem 0", userSelect: "text" }}>
                    {phone}
                </div>
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx(styles.okButton)}
            >
                OK
            </StyledButton>
        </>
    );
}

/** T2-6106: block Change Shift Time after the shift has started */
export const ShiftStartedModal = ({ isOpen, onClose}: { isOpen: boolean, onClose: () => void }) => {
    return (
        <SimpleModal isOpen={isOpen} onClose={onClose}>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Shift Has Started</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onClose}
                                  data-testid="shift-started-modal-close-button"
                                  aria-label="Close Shift Has Started dialog"
                                  content-desc="shift-started-modal-close-button"/>
            </div>
            <div className={styles.description}>
                The shift has started and we no longer allow the shift times to be updated
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onClose}
                className={clsx(styles.okButton)}
                id="shift-started-modal-ok-button"
                data-testid="shift-started-modal-ok-button"
                aria-label="OK"
            >
                OK
            </StyledButton>
        </SimpleModal>
    );
}

export const ModifyShiftModal = ({
    firstName,
    onSubmit,
    onCloseButtonClick,
    showShortNoticeWarning = false,
}: {
    firstName: string,
    onSubmit: (e: any) => void,
    onCloseButtonClick: (e: any) => void,
    showShortNoticeWarning?: boolean,
}) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>READ CAREFULLY</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                Modifying the shift time of a booked shift is changing your agreement and commitment with {firstName}.
                <br/><br/>
                {firstName} will be notified about your shift change.
                <b> Changes to the original hours you booked may result in {firstName} having to cancel this shift.</b>
                {showShortNoticeWarning && (
                    <>
                        {' '}
                        If {firstName} has to cancel because of the shift changes you made, that does fall under you
                        breaking the original agreement and your office will be subject to pay {firstName} the Short
                        Notice Cancellation fee. <b>It's recommended to keep the original hours.</b>
                        <br/>
                        <a
                            href={CHANGE_SHIFT_HOURS_POLICY}
                            className={clsx(styles.policyLink, 'external', 'no-fastclick')}
                            target="_system"
                            rel="noopener noreferrer"
                            id="modify-shift-policy-link"
                            data-testid="modify-shift-policy-link"
                            aria-label="Open change shift policy"
                            content-desc="modify-shift-policy-link"
                            onClick={(event) => openExternalUrlFromLink(event.nativeEvent, CHANGE_SHIFT_HOURS_POLICY)}
                        >
                            Click here to view policy
                        </a>
                    </>
                )}
                <br/><br/>
                In the event {firstName} needs to cancel because of this change, we will notify you via email -
                so be sure to monitor your inbox.<br/><br/>
                Are you sure?
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
            >
                No
            </StyledButton>
            <StyledButton
                variant="contained"
                size="large"
                onClick={onSubmit}
            >
                Yes
            </StyledButton>
        </>
    );
}
